import { render, staticRenderFns } from "./zhuantilanmu.vue?vue&type=template&id=4b211765"
import script from "./zhuantilanmu.vue?vue&type=script&lang=js"
export * from "./zhuantilanmu.vue?vue&type=script&lang=js"
import style0 from "./zhuantilanmu.vue?vue&type=style&index=0&id=4b211765&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports